import { BrandDocument } from '@models/brand';
import { ProductDocument } from '@models/product';
import Link from 'next/link';
import React from 'react';
import { slugify } from '@util/urlHelpers';

const BikeDetails = ({
  product,
}: {
  product: ProductDocument;
  brand?: BrandDocument | null;
}) => {
  return (
    <>
      <h3 className="mb-[0.4rem] text-[1.5rem] font-semibold">Details</h3>

      <div className="flex w-full flex-col whitespace-nowrap">
        <div className="mb-[0.4rem] flex">
          <p className="w-[10rem] text-[1.5rem]">Condition:</p>
          <Link
            href={`/${product.condition?.toLowerCase()}-dirt-bikes-for-sale`}
            className="grow"
          >
            {product.condition || 'N/A'}
          </Link>
        </div>

        <div className="mb-[0.4rem] flex">
          <p className="w-[10rem] text-[1.5rem]">Make:</p>
          <Link
            className="grow font-semibold text-brand-secondary"
            href={`/${product.make
              ?.toLowerCase()
              .replaceAll(' ', '-')}-dirt-bikes-for-sale/`}
          >
            {product.make}
          </Link>
        </div>
        <div className="mb-[0.4rem] flex">
          <p className="w-[10rem] text-[1.5rem]">Year:</p>
          <Link
            className="grow font-semibold text-brand-secondary"
            href={`/${product.year}-dirt-bikes-for-sale`}
          >
            {product.year || 'N/A'}
          </Link>
        </div>
        <div className="mb-[0.4rem] flex">
          <p className="w-[10rem] text-[1.5rem]">Model:</p>
          <Link
            href={`/${slugify(product.model ?? '')}-dirt-bikes-for-sale`}
            className="grow font-semibold text-brand-secondary"
          >
            {product.model || 'N/A'}
          </Link>
        </div>
        <div className="mb-[0.4rem] flex">
          <p className="w-[10rem] text-[1.5rem]">Location:</p>
          <Link
            className="grow font-semibold text-brand-secondary"
            href={`/dirt-bikes-for-sale${
              product.location_display
                ? `-near-${slugify(product.location_display)}`
                : ''
            }`}
          >
            {product.location_display || 'N/A'}
          </Link>
        </div>
      </div>
    </>
  );
};

export default BikeDetails;
